import Axios from "axios";
import {
    SET_PRODUCT_LIST,
    UNSET_PRODUCT_LIST,
    SET_PRODUCT_CSV,
    UNSET_PRODUCT_CSV,
  } from "@/store/mutation-types";
import { saveUpdateProduct, getProductList, generateProductCode , importProductCSV} from "@/store/api";
// initial state
const state = {
  getProductList: [],
  editingProduct: null,
};

const getters = {
  getProductList(state) {
    return state.getProductList;
  },
  getEditingProduct: (state) => { 
    return state.editingProduct;
  },
};

const mutations = {
  [SET_PRODUCT_LIST](state, data) {
    state.getProductList = data;
  },
  [UNSET_PRODUCT_LIST](state) {
    state.getProductList = [];
  },
  setEditingProduct(state, product) {
    state.editingProduct = product;
  },
  clearEditingProduct(state) {
    state.editingProduct = null;
  }
};

const actions = {

  saveUpdateProduct({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateProduct, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getProductList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getProductList, data)
        .then(function (response) {
          commit('SET_PRODUCT_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_PRODUCT_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  getProductById({ commit }, data) {
    const getProductById = `${getProductList}/${data}`;
    commit("SET_LOADING", {color: "primary"});  
    return new Promise((resolve, reject) => {
      Axios.get(getProductById)
        .then((response) => {
          resolve(response.data.code);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getGeneratedProductCode({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(generateProductCode)
        .then((response) => {
          resolve(response.data.code);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  importProductCSV({commit}, formData){
    return new Promise((resolve , reject) => {
      Axios.post(importProductCSV , formData)
      .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    })
  }


};

export default {
  state,
  getters,
  actions,
  mutations,
};
